let timer = {
  counter: 0,
  timeout: null,
  accuracy: 100, // in miliseconds
  start() {
    this.timeout = setTimeout(() => {
      this.counter += this.accuracy;
      this.start();
    }, this.accuracy);
  },
  stop() {
    return new Promise(resolve => {
      clearTimeout(this.timeout);
      resolve(this.counter);
    })
  }
}

export default timer;